import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AssetRatingProfileResponse, AssetRatingProfileCreateRequest, AssetRatingProfileUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper, EnumToComboValues } from '../utils';
import { AssetRatingProfileDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { EventFilterService } from 'app/services/events/event-filter.service';

@RegisterEntityHandler('assetratingprofile')
@Injectable()
export class AssetRatingProfileHandler extends EntityHandler<AssetRatingProfileResponse> {

    constructor(
        admin: AdminEditorService,
        private filters: EventFilterService
    ) {
        super(admin);
    }

    states = ['active', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listAssetRatingProfiles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listAssetRatingProfiles(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'assetratingprofile',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ASSETRATINGPROFILES'),
        }));
    }

    getEntity(id: string): Promise<AssetRatingProfileResponse> {
        return this.admin.getCached(`getAssetRatingProfile/${id}`, api => api.entities.getAssetRatingProfile(id), 10);
    }

    createEntity(ownerId: string, entity: AssetRatingProfileCreateRequest): Promise<AssetRatingProfileResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createAssetRatingProfile(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateAssetRatingProfile(entity.id, { state: state as any }));
    }

    getGridIcon(item: AssetRatingProfileResponse): string {
        return item.items && item.items.length > 0 ? ICONS.assetratingprofile : 'exclamation-triangle';
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ASSETRATINGPROFILE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', this.getGridIcon),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<AssetRatingProfileResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new AssetRatingProfileDetailsSectionHandler(this.admin, this.filters, ownerId, false),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: AssetRatingProfileUpdateRequest, sections: FormSectionHandler<AssetRatingProfileResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'assetratingprofile',
            entity: {}, // set up some defaults if you want
            sections: [
                new AssetRatingProfileDetailsSectionHandler(this.admin, this.filters, ownerId, true),
            ],
        });
    }

}












